/* RESPONSIBLE TEAM: team-data-foundations */
import SetupAction from 'embercom/models/workflow-connector/setup-action';

// Thin subclass of SetupAction that maps to the AiAutomationActionsController endpoint.
// The backend controller is itself a subclass of SetupActionsController with the same
// response shape, gated behind the access_fin_and_automation_settings permission.
export default class AiAutomationAction extends SetupAction {}
